import React from 'react';
import { MdPerson,MdDescription } from 'react-icons/md';
import './App.css';
import DeizuButton from './buttons/DeizuButton'

function App() {
  function Home() {
    return (
      <div className="startMenu">
          <div className="centerDiv">
            <section className="card">
              <h1>サイトを移行させて頂きました。</h1>
              <p>
                こちらのサイトで時間割表を作成していた人のデータは保存されていますので、新しいサイトで同じようにログインして頂ければ問題なく閲覧できます。
                <br/>
                お手数をお掛け申し訳ございません。
              </p>
              <div className="centerBtn">
                <DeizuButton
                  btnClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://deizu.vercel.app/app';
                  }}
                  btnIcon={<MdPerson className="btnIcon" />}
                  btnName="新サイトでログイン"
                />
                <DeizuButton
                  btnClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://deizu.vercel.app/';
                  }}
                  btnIcon={<MdDescription className="btnIcon" />}
                  btnName="サイトへ移動"
                />
              </div>
            </section>
          </div>
      </div>
    )
  }

  return (
    <div className="App">
      <Home />
      {/* {user ? <Dashboard /> : } */}
    </div>
  );
}

export default App;